import {
  dashboardChartFilterAndActionTypes,
  dashboardEventTypes,
} from "../utils/constants/dashboard/analyticDashboardEvents";
import { DASHBOARD_CHART_TYPES } from "../utils/constants/dashboard/dashboardModuleConstants";

import {
  getTenantIdState,
  getUserPlanState,
  getUserProfileState,
  getUserStatusState,
  getUserIdState,
} from "../selectors/userInfoSelectors";
import reduxStoreHelper from "../utils/helpers/reduxStoreHelper";
import analyticEventService from "./analyticEventService";
import { AnalyticMetaData } from "@customTypes/services/analyticEvents";
import { ChartIdentificationType } from "@customTypes/chart";

const getDefaultMetaData = (): AnalyticMetaData => {
  const rootState = reduxStoreHelper.getState();

  const metaData = {
    tenantId: getTenantIdState(rootState),
    userId: getUserIdState(rootState),
    userProfile: getUserProfileState(rootState),
    tenantStatus: getUserStatusState(rootState),
    plan: getUserPlanState(rootState),
  };
  return metaData;
};

export const sendEventModuleOpen = () => {
  const metaData = getDefaultMetaData();
  analyticEventService.sendEvent("ALL", dashboardEventTypes.MODULE_OPEN, metaData);
};

export const sendEventTabOpen = (dashboardTabSubTypes: string) => {
  const metaData = getDefaultMetaData();
  metaData.tabOpened = dashboardTabSubTypes;
  analyticEventService.sendEvent("ALL", dashboardEventTypes.TAB_OPEN, metaData);
};

export const sendEventChartUsed = (
  dashboardChartType: { module: string; chart: string },
  dashboardChartFilterAndActionType: string,
  dashboardChartFilterAndActionDescription:
    | string
    | { queryParam: string[]; label: string }
    | null = null
) => {
  const metaData = getDefaultMetaData();
  metaData.module = dashboardChartType.module;
  metaData.chart = dashboardChartType.chart;
  metaData.action = dashboardChartFilterAndActionType;
  metaData.actionDescription = dashboardChartFilterAndActionDescription;
  analyticEventService.sendEvent("ALL", dashboardEventTypes.CHART_USED, metaData);
};

export const getDashboardChartTypeByChartId = (chartId: string) => {
  const [, chartType] = Object.entries(DASHBOARD_CHART_TYPES).find(
    ([, value]) => value.chart === chartId
  );
  return chartType || { module: "", chart: chartId };
};

export const sendEventLegendClick = (chartId: string) => {
  const chartType = getDashboardChartTypeByChartId(chartId);
  sendEventChartUsed(chartType, dashboardChartFilterAndActionTypes.LEGEND_CLICK);
};

export const sendEventEmptyStateClick = (
  dashboardChartEmptyStatesTypes: React.ReactNode,
  dashboardChartType: ChartIdentificationType = { module: "", chart: "" }
) => {
  const metaData = getDefaultMetaData();
  metaData.module = dashboardChartType.module;
  metaData.chart = dashboardChartType.chart;
  metaData.action = dashboardChartEmptyStatesTypes;
  analyticEventService.sendEvent("ALL", dashboardEventTypes.EMPTY_STATE, metaData);
};
